import isFunction from 'lodash/isFunction';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';

export const CALL_API = 'CALL_API';
export const API_UNAUTHORIZED = 'API_UNAUTHORIZED';
export const HEADER_DISABLE_REDIRECT = 'X-Disable-Redirect';

const prepareResponse = response => {
    const body = (() => {
        switch (response.headers.get('Content-Type')) {
            case 'application/json':
                return response.json();
            case 'text/plain':
                return response.text();
            default:
                return Promise.resolve(null);
        }
    })();

    return body.then(value => ({
        ok: response.ok,
        status: response.status,
        body: value,
    }));
};

const endpointToUrl = (endpoint, getState) => {
    let url;
    if (isString(endpoint)) {
        url = endpoint;
    } else if (isFunction(endpoint)) {
        url = endpoint(getState());
    } else {
        throw new Error(`Invalid endpoint "${endpoint}"`);
    }
    return url;
};

const dataToAction = (entity, data, payload) => {
    let action;
    if (isString(data)) {
        action = { type: data, payload };
    } else if (isPlainObject(data)) {
        action = data;
    } else {
        throw new Error(`Invalid ${entity} ${data}`);
    }
    return action;
};

export default store => next => action => {
    if (!(CALL_API in action)) {
        return next(action);
    }
    const { endpoint, request, success, failure, ...init } = action[CALL_API];

    const url = endpointToUrl(endpoint, () => store.getState());

    if (request) {
        next(dataToAction('request', request));
    }

    if (!init.headers) {
        init.headers = new Headers();
    }
    // by default disable redirect if unauthorized
    if (!init.headers.has(HEADER_DISABLE_REDIRECT)) {
        init.headers.set(HEADER_DISABLE_REDIRECT, true);
    }

    return fetch(url, init)
        .then(prepareResponse)
        .catch(error => ({
            ok: false,
            status: null,
            body: error.message,
        }))
        .then((payload) => {
            if (payload.status === 401) {
                next({ type: API_UNAUTHORIZED });
            }

            const result = payload.ok ? success : failure;

            if (!result) return payload;

            if (isFunction(result)) {
                return result(next, payload, store.getState());
            }

            next(dataToAction('result', result, payload));

            return payload;
        });
};



// WEBPACK FOOTER //
// ./src/js/middleware/api.js